(function() { var WEB=true; // This is included at the top of each compiled type file for the web.
/**
   @const
   @type {boolean}
*/

// client build is concatenating all those files into a single file and let/const variables
// can't be redeclared, while var can, disable this rule here for now
// eslint-disable-next-line no-var
var WEB = true;
// eslint-disable-next-line no-var
var exports;

if (!window.sharejs) {
   window.sharejs = {};
}
exports = window.sharejs;
// These methods let you build a transform function from a transformComponent function
// for OT types like text and JSON in which operations are lists of components
// and transforming them requires N^2 work.

// Add transform and transformX functions for an OT type which has transformComponent defined.
// transformComponent(destination array, component, other component, side)
var bootstrapTransform = void 0;

exports['_bt'] = bootstrapTransform = function bootstrapTransform(type, transformComponent, checkValidOp, append) {
  var transformComponentX = void 0,
      _transformX2 = void 0;
  transformComponentX = function transformComponentX(left, right, destLeft, destRight) {
    transformComponent(destLeft, left, right, 'left');
    return transformComponent(destRight, right, left, 'right');
  };
  // Transforms rightOp by leftOp. Returns ['rightOp', clientOp']
  type.transformX = type['transformX'] = _transformX2 = function transformX(leftOp, rightOp) {
    var i = void 0,
        j = void 0,
        k = void 0,
        l = void 0,
        l_ = void 0,
        len = void 0,
        len1 = void 0,
        len2 = void 0,
        len3 = void 0,
        m = void 0,
        n = void 0,
        newLeftOp = void 0,
        newRightOp = void 0,
        nextC = void 0,
        r = void 0,
        r_ = void 0,
        ref = void 0,
        rightComponent = void 0;
    checkValidOp(leftOp);
    checkValidOp(rightOp);
    newRightOp = [];
    for (i = 0, len = rightOp.length; i < len; i++) {
      rightComponent = rightOp[i];
      // Generate newLeftOp by composing leftOp by rightComponent
      newLeftOp = [];
      k = 0;
      while (k < leftOp.length) {
        nextC = [];
        transformComponentX(leftOp[k], rightComponent, newLeftOp, nextC);
        k++;
        if (nextC.length === 1) {
          rightComponent = nextC[0];
        } else if (nextC.length === 0) {
          ref = leftOp.slice(k);
          for (j = 0, len1 = ref.length; j < len1; j++) {
            l = ref[j];
            append(newLeftOp, l);
          }
          rightComponent = null;
          break;
        } else {
          var _transformX = _transformX2(leftOp.slice(k), nextC);
          // Recurse.


          l_ = _transformX[0];
          r_ = _transformX[1];

          for (m = 0, len2 = l_.length; m < len2; m++) {
            l = l_[m];
            append(newLeftOp, l);
          }
          for (n = 0, len3 = r_.length; n < len3; n++) {
            r = r_[n];
            append(newRightOp, r);
          }
          rightComponent = null;
          break;
        }
      }
      if (rightComponent != null) {
        append(newRightOp, rightComponent);
      }
      leftOp = newLeftOp;
    }
    return [leftOp, newRightOp];
  };
  // Transforms op with specified type ('left' or 'right') by otherOp.
  return type.transform = type['transform'] = function (op, otherOp, type) {
    var _ = void 0,
        left = void 0,
        right = void 0;
    if (!(type === 'left' || type === 'right')) {
      throw new Error("type must be 'left' or 'right'");
    }
    if (otherOp.length === 0) {
      return op;
    }
    if (op.length === 1 && otherOp.length === 1) {
      // TODO: Benchmark with and without this line. I _think_ it'll make a big difference...?
      return transformComponent([], op[0], otherOp[0], type);
    }
    if (type === 'left') {
      var _transformX3 = _transformX2(op, otherOp);

      left = _transformX3[0];
      _ = _transformX3[1];

      return left;
    } else {
      var _transformX4 = _transformX2(otherOp, op);

      _ = _transformX4[0];
      right = _transformX4[1];

      return right;
    }
  };
};

if (typeof WEB === 'undefined') {
  exports.bootstrapTransform = bootstrapTransform;
}
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// A simple text implementation

// Operations are lists of components.
// Each component either inserts or deletes at a specified position in the document.

// Components are either:
//  {i:'str', p:100}: Insert 'str' at position 100 in the document
//  {d:'str', p:100}: Delete 'str' at position 100 in the document

// Components in an operation are executed sequentially, so the position of components
// assumes previous components have already executed.

// Eg: This op:
//   [{i:'abc', p:0}]
// is equivalent to this op:
//   [{i:'a', p:0}, {i:'b', p:1}, {i:'c', p:2}]

// NOTE: The global scope here is shared with other sharejs files when built with closure.
// Be careful what ends up in your namespace.

// client build is concatenating all those files into a single file and let/const variables
// can't be redeclared, while var can, disable this rule here for now
// eslint-disable-next-line no-var
var append, checkValidComponent, checkValidOp, invertComponent, strInject, text, transformComponent, transformPosition;

text = {};

text.name = 'text';

text.create = function () {
  return '';
};

strInject = function strInject(s1, pos, s2) {
  return s1.slice(0, pos) + s2 + s1.slice(pos);
};

checkValidComponent = function checkValidComponent(c) {
  var d_type = void 0,
      i_type = void 0;
  if (typeof c.p !== 'number') {
    throw new Error('component missing position field');
  }
  i_type = _typeof(c.i);
  d_type = _typeof(c.d);
  if (!(i_type === 'string' ^ d_type === 'string')) {
    throw new Error('component needs an i or d field');
  }
  if (!(c.p >= 0)) {
    throw new Error('position cannot be negative');
  }
};

checkValidOp = function checkValidOp(op) {
  var c = void 0,
      i = void 0,
      len = void 0;
  for (i = 0, len = op.length; i < len; i++) {
    c = op[i];
    checkValidComponent(c);
  }
  return true;
};

text.apply = function (snapshot, op) {
  var component = void 0,
      deleted = void 0,
      i = void 0,
      len = void 0;
  checkValidOp(op);
  for (i = 0, len = op.length; i < len; i++) {
    component = op[i];
    if (component.i != null) {
      snapshot = strInject(snapshot, component.p, component.i);
    } else {
      deleted = snapshot.slice(component.p, component.p + component.d.length);
      if (component.d !== deleted) {
        throw new Error('Delete component \'' + component.d + '\' does not match deleted text \'' + deleted + '\'');
      }
      snapshot = snapshot.slice(0, component.p) + snapshot.slice(component.p + component.d.length);
    }
  }
  return snapshot;
};

// Exported for use by the random op generator.

// For simplicity, this version of append does not compress adjacent inserts and deletes of
// the same text. It would be nice to change that at some stage.
text._append = append = function append(newOp, c) {
  var last = void 0,
      ref = void 0,
      ref1 = void 0;
  if (c.i === '' || c.d === '') {
    return;
  }
  if (newOp.length === 0) {
    return newOp.push(c);
  } else {
    last = newOp[newOp.length - 1];
    // Compose the insert into the previous insert if possible
    if (last.i != null && c.i != null && last.p <= (ref = c.p) && ref <= last.p + last.i.length) {
      return newOp[newOp.length - 1] = {
        i: strInject(last.i, c.p - last.p, c.i),
        p: last.p
      };
    } else if (last.d != null && c.d != null && c.p <= (ref1 = last.p) && ref1 <= c.p + c.d.length) {
      return newOp[newOp.length - 1] = {
        d: strInject(c.d, last.p - c.p, last.d),
        p: c.p
      };
    } else {
      return newOp.push(c);
    }
  }
};

text.compose = function (op1, op2) {
  var c = void 0,
      i = void 0,
      len = void 0,
      newOp = void 0;
  checkValidOp(op1);
  checkValidOp(op2);
  newOp = op1.slice();
  for (i = 0, len = op2.length; i < len; i++) {
    c = op2[i];
    append(newOp, c);
  }
  return newOp;
};

// Attempt to compress the op components together 'as much as possible'.
// This implementation preserves order and preserves create/delete pairs.
text.compress = function (op) {
  return text.compose([], op);
};

text.normalize = function (op) {
  var c = void 0,
      i = void 0,
      len = void 0,
      newOp = void 0;
  newOp = [];
  if (op.i != null || op.p != null) {
    // Normalize should allow ops which are a single (unwrapped) component:
    // {i:'asdf', p:23}.
    // There's no good way to test if something is an array:
    // http://perfectionkills.com/instanceof-considered-harmful-or-how-to-write-a-robust-isarray/
    // so this is probably the least bad solution.
    op = [op];
  }
  for (i = 0, len = op.length; i < len; i++) {
    c = op[i];
    if (c.p == null) {
      c.p = 0;
    }
    append(newOp, c);
  }
  return newOp;
};

// This helper method transforms a position by an op component.

// If c is an insert, insertAfter specifies whether the transform
// is pushed after the insert (true) or before it (false).

// insertAfter is optional for deletes.
transformPosition = function transformPosition(pos, c, insertAfter) {
  if (c.i != null) {
    if (c.p < pos || c.p === pos && insertAfter) {
      return pos + c.i.length;
    } else {
      return pos;
    }
  } else {
    // I think this could also be written as: Math.min(c.p, Math.min(c.p - otherC.p, otherC.d.length))
    // but I think its harder to read that way, and it compiles using ternary operators anyway
    // so its no slower written like this.
    if (pos <= c.p) {
      return pos;
    } else if (pos <= c.p + c.d.length) {
      return c.p;
    } else {
      return pos - c.d.length;
    }
  }
};

// Helper method to transform a cursor position as a result of an op.

// Like transformPosition above, if c is an insert, insertAfter specifies whether the cursor position
// is pushed after an insert (true) or before it (false).
text.transformCursor = function (position, op, side) {
  var c = void 0,
      i = void 0,
      insertAfter = void 0,
      len = void 0;
  insertAfter = side === 'right';
  for (i = 0, len = op.length; i < len; i++) {
    c = op[i];
    position = transformPosition(position, c, insertAfter);
  }
  return position;
};

// Transform an op component by another op component. Asymmetric.
// The result will be appended to destination.

// exported for use in JSON type
text._tc = transformComponent = function transformComponent(dest, c, otherC, side) {
  var cIntersect = void 0,
      intersectEnd = void 0,
      intersectStart = void 0,
      newC = void 0,
      otherIntersect = void 0,
      s = void 0;
  checkValidOp([c]);
  checkValidOp([otherC]);
  if (c.i != null) {
    append(dest, {
      i: c.i,
      p: transformPosition(c.p, otherC, side === 'right') // Delete
    });
  } else {
    if (otherC.i != null) {
      s = c.d;
      if (c.p < otherC.p) {
        append(dest, {
          d: s.slice(0, otherC.p - c.p),
          p: c.p
        });
        s = s.slice(otherC.p - c.p);
      }
      if (s !== '') {
        append(dest, {
          d: s,
          p: c.p + otherC.i.length // Delete vs delete
        });
      }
    } else {
      if (c.p >= otherC.p + otherC.d.length) {
        append(dest, {
          d: c.d,
          p: c.p - otherC.d.length
        });
      } else if (c.p + c.d.length <= otherC.p) {
        append(dest, c);
      } else {
        // They overlap somewhere.
        newC = {
          d: '',
          p: c.p
        };
        if (c.p < otherC.p) {
          newC.d = c.d.slice(0, otherC.p - c.p);
        }
        if (c.p + c.d.length > otherC.p + otherC.d.length) {
          newC.d += c.d.slice(otherC.p + otherC.d.length - c.p);
        }
        // This is entirely optional - just for a check that the deleted
        // text in the two ops matches
        intersectStart = Math.max(c.p, otherC.p);
        intersectEnd = Math.min(c.p + c.d.length, otherC.p + otherC.d.length);
        cIntersect = c.d.slice(intersectStart - c.p, intersectEnd - c.p);
        otherIntersect = otherC.d.slice(intersectStart - otherC.p, intersectEnd - otherC.p);
        if (cIntersect !== otherIntersect) {
          throw new Error('Delete ops delete different text in the same region of the document');
        }
        if (newC.d !== '') {
          // This could be rewritten similarly to insert v delete, above.
          newC.p = transformPosition(newC.p, otherC);
          append(dest, newC);
        }
      } // delete vs insert
    }
  }
  return dest;
};

invertComponent = function invertComponent(c) {
  if (c.i != null) {
    return {
      d: c.i,
      p: c.p
    };
  } else {
    return {
      i: c.d,
      p: c.p
    };
  }
};

// No need to use append for invert, because the components won't be able to
// cancel with one another.
text.invert = function (op) {
  var c = void 0,
      i = void 0,
      len = void 0,
      ref = void 0,
      results = void 0;
  ref = op.slice().reverse();
  results = [];
  for (i = 0, len = ref.length; i < len; i++) {
    c = ref[i];
    results.push(invertComponent(c));
  }
  return results;
};

if (typeof WEB !== 'undefined' && WEB !== null) {
  exports.types || (exports.types = {});
  // This is kind of awful - come up with a better way to hook this helper code up.
  bootstrapTransform(text, transformComponent, checkValidOp, append);
  // [] is used to prevent closure from renaming types.text
  exports.types.text = text;
} else {
  module.exports = text;
  // The text type really shouldn't need this - it should be possible to define
  // an efficient transform function by making a sort of transform map and passing each
  // op component through it.
  require('./helpers').bootstrapTransform(text, transformComponent, checkValidOp, append);
}
// Text document API for text

// client build is concatenating all those files into a single file and let/const variables
// can't be redeclared, while var can, disable this rule here for now
// eslint-disable-next-line no-var
var text;

if (typeof WEB === 'undefined') {
  text = require('./text');
}

text.api = {
  provides: {
    text: true
  },
  // The number of characters in the string
  getLength: function getLength() {
    return this.snapshot.length;
  },
  // Get the text contents of a document
  getText: function getText() {
    return this.snapshot;
  },
  insert: function insert(pos, text, callback) {
    var op = void 0;
    op = [{
      p: pos,
      i: text
    }];
    this.submitOp(op, callback);
    return op;
  },
  del: function del(pos, length, callback) {
    var op = void 0;
    op = [{
      p: pos,
      d: this.snapshot.slice(pos, pos + length)
    }];
    this.submitOp(op, callback);
    return op;
  },
  _register: function _register() {
    return this.on('remoteop', function (op) {
      var component = void 0,
          i = void 0,
          len = void 0,
          results = void 0;
      results = [];
      for (i = 0, len = op.length; i < len; i++) {
        component = op[i];
        if (component.i !== void 0) {
          results.push(this.emit('insert', component.p, component.i));
        } else {
          results.push(this.emit('delete', component.p, component.d));
        }
      }
      return results;
    });
  }
};
// This is the implementation of the JSON OT type.

// Spec is here: https://github.com/josephg/ShareJS/wiki/JSON-Operations

// Note: This is obsolete, and will be replaced by the JSON2 type.

// client build is concatenating all those files into a single file and let/const variables
// can't be redeclared, while var can, disable this rule here for now
// eslint-disable-next-line no-var
var clone, isArray, json, text;

if (typeof WEB !== 'undefined' && WEB !== null) {
  text = exports.types.text;
} else {
  text = require('./text');
}

json = {};

json.name = 'json';

json.create = function () {
  return null;
};

json.invertComponent = function (c) {
  var c_ = void 0;
  c_ = {
    p: c.p
  };
  if (c.si !== void 0) {
    c_.sd = c.si;
  }
  if (c.sd !== void 0) {
    c_.si = c.sd;
  }
  if (c.oi !== void 0) {
    c_.od = c.oi;
  }
  if (c.od !== void 0) {
    c_.oi = c.od;
  }
  if (c.li !== void 0) {
    c_.ld = c.li;
  }
  if (c.ld !== void 0) {
    c_.li = c.ld;
  }
  if (c.na !== void 0) {
    c_.na = -c.na;
  }
  if (c.lm !== void 0) {
    c_.lm = c.p[c.p.length - 1];
    c_.p = c.p.slice(0, c.p.length - 1).concat([c.lm]);
  }
  return c_;
};

json.invert = function (op) {
  var c = void 0,
      j = void 0,
      len = void 0,
      ref = void 0,
      results = void 0;
  ref = op.slice().reverse();
  results = [];
  for (j = 0, len = ref.length; j < len; j++) {
    c = ref[j];
    results.push(json.invertComponent(c));
  }
  return results;
};

json.checkValidOp = function (op) {};

isArray = function isArray(o) {
  return Object.prototype.toString.call(o) === '[object Array]';
};

json.checkList = function (elem) {
  if (!isArray(elem)) {
    throw new Error('Referenced element not a list');
  }
};

json.checkObj = function (elem) {
  if (elem.constructor !== Object) {
    throw new Error('Referenced element not an object (it was ' + JSON.stringify(elem) + ')');
  }
};

json.apply = function (snapshot, op) {
  var c = void 0,
      container = void 0,
      e = void 0,
      elem = void 0,
      error = void 0,
      i = void 0,
      j = void 0,
      k = void 0,
      key = void 0,
      len = void 0,
      len1 = void 0,
      p = void 0,
      parent = void 0,
      parentkey = void 0,
      ref = void 0;
  json.checkValidOp(op);
  op = clone(op);
  container = {
    data: clone(snapshot)
  };
  try {
    for (i = j = 0, len = op.length; j < len; i = ++j) {
      c = op[i];
      parent = null;
      parentkey = null;
      elem = container;
      key = 'data';
      ref = c.p;
      for (k = 0, len1 = ref.length; k < len1; k++) {
        p = ref[k];
        parent = elem;
        parentkey = key;
        elem = elem[key];
        key = p;
        if (parent == null) {
          throw new Error('Path invalid');
        }
      }
      if (c.na !== void 0) {
        if (typeof elem[key] !== 'number') {
          // Number add
          throw new Error('Referenced element not a number');
        }
        elem[key] += c.na;
      } else if (c.si !== void 0) {
        if (typeof elem !== 'string') {
          // String insert
          throw new Error('Referenced element not a string (it was ' + JSON.stringify(elem) + ')');
        }
        parent[parentkey] = elem.slice(0, key) + c.si + elem.slice(key);
      } else if (c.sd !== void 0) {
        if (typeof elem !== 'string') {
          // String delete
          throw new Error('Referenced element not a string');
        }
        if (elem.slice(key, key + c.sd.length) !== c.sd) {
          throw new Error('Deleted string does not match');
        }
        parent[parentkey] = elem.slice(0, key) + elem.slice(key + c.sd.length);
      } else if (c.li !== void 0 && c.ld !== void 0) {
        // List replace
        json.checkList(elem);
        // Should check the list element matches c.ld
        elem[key] = c.li;
      } else if (c.li !== void 0) {
        // List insert
        json.checkList(elem);
        elem.splice(key, 0, c.li);
      } else if (c.ld !== void 0) {
        // List delete
        json.checkList(elem);
        // Should check the list element matches c.ld here too.
        elem.splice(key, 1);
      } else if (c.lm !== void 0) {
        // List move
        json.checkList(elem);
        if (c.lm !== key) {
          e = elem[key];
          // Remove it...
          elem.splice(key, 1);
          // And insert it back.
          elem.splice(c.lm, 0, e);
        }
      } else if (c.oi !== void 0) {
        // Object insert / replace
        json.checkObj(elem);

        // Should check that elem[key] == c.od
        elem[key] = c.oi;
      } else if (c.od !== void 0) {
        // Object delete
        json.checkObj(elem);
        // Should check that elem[key] == c.od
        delete elem[key];
      } else {
        throw new Error('invalid / missing instruction in op');
      }
    }
  } catch (error1) {
    error = error1;
    // TODO: Roll back all already applied changes. Write tests before implementing this code.
    throw error;
  }
  return container.data;
};

// Checks if two paths, p1 and p2 match.
json.pathMatches = function (p1, p2, ignoreLast) {
  var i = void 0,
      j = void 0,
      len = void 0,
      p = void 0;
  if (p1.length !== p2.length) {
    return false;
  }
  for (i = j = 0, len = p1.length; j < len; i = ++j) {
    p = p1[i];
    if (p !== p2[i] && (!ignoreLast || i !== p1.length - 1)) {
      return false;
    }
  }
  return true;
};

json.append = function (dest, c) {
  var last = void 0;
  c = clone(c);
  if (dest.length !== 0 && json.pathMatches(c.p, (last = dest[dest.length - 1]).p)) {
    if (last.na !== void 0 && c.na !== void 0) {
      return dest[dest.length - 1] = {
        p: last.p,
        na: last.na + c.na
      };
    } else if (last.li !== void 0 && c.li === void 0 && c.ld === last.li) {
      // insert immediately followed by delete becomes a noop.
      if (last.ld !== void 0) {
        // leave the delete part of the replace
        return delete last.li;
      } else {
        return dest.pop();
      }
    } else if (last.od !== void 0 && last.oi === void 0 && c.oi !== void 0 && c.od === void 0) {
      return last.oi = c.oi;
    } else if (c.lm !== void 0 && c.p[c.p.length - 1] === c.lm) {
      return null; // don't do anything
    } else {
      return dest.push(c);
    }
  } else {
    return dest.push(c);
  }
};

json.compose = function (op1, op2) {
  var c = void 0,
      j = void 0,
      len = void 0,
      newOp = void 0;
  json.checkValidOp(op1);
  json.checkValidOp(op2);
  newOp = clone(op1);
  for (j = 0, len = op2.length; j < len; j++) {
    c = op2[j];
    json.append(newOp, c);
  }
  return newOp;
};

json.normalize = function (op) {
  var c = void 0,
      j = void 0,
      len = void 0,
      newOp = void 0;
  newOp = [];
  if (!isArray(op)) {
    op = [op];
  }
  for (j = 0, len = op.length; j < len; j++) {
    c = op[j];
    if (c.p == null) {
      c.p = [];
    }
    json.append(newOp, c);
  }
  return newOp;
};

// hax, copied from test/types/json. Apparently this is still the fastest way to deep clone an object, assuming
// we have browser support for JSON.
// http://jsperf.com/cloning-an-object/12
clone = function clone(o) {
  return JSON.parse(JSON.stringify(o));
};

// Returns true if an op at otherPath may affect an op at path
json.canOpAffectOp = function (otherPath, path) {
  var i = void 0,
      j = void 0,
      len = void 0,
      p = void 0;
  if (otherPath.length === 0) {
    return true;
  }
  if (path.length === 0) {
    return false;
  }
  path = path.slice(0, path.length - 1);
  otherPath = otherPath.slice(0, otherPath.length - 1);
  for (i = j = 0, len = otherPath.length; j < len; i = ++j) {
    p = otherPath[i];
    if (i >= path.length) {
      return false;
    }
    if (p !== path[i]) {
      return false;
    }
  }
  // Same
  return true;
};

// transform c so it applies to a document with otherC applied.
json.transformComponent = function (dest, c, otherC, type) {
  var common = void 0,
      common2 = void 0,
      commonOperand = void 0,
      convert = void 0,
      cplength = void 0,
      from = void 0,
      j = void 0,
      jc = void 0,
      len = void 0,
      oc = void 0,
      otherCplength = void 0,
      otherFrom = void 0,
      otherTo = void 0,
      p = void 0,
      res = void 0,
      tc = void 0,
      tc1 = void 0,
      tc2 = void 0,
      to = void 0;
  c = clone(c);
  if (c.na !== void 0) {
    c.p.push(0);
  }
  if (otherC.na !== void 0) {
    otherC.p.push(0);
  }
  if (json.canOpAffectOp(otherC.p, c.p)) {
    common = otherC.p.length - 1;
  }
  if (json.canOpAffectOp(c.p, otherC.p)) {
    common2 = c.p.length - 1;
  }
  cplength = c.p.length;
  otherCplength = otherC.p.length;
  if (c.na !== void 0) {
    // hax
    c.p.pop();
  }
  if (otherC.na !== void 0) {
    otherC.p.pop();
  }
  if (otherC.na) {
    if (common2 != null && otherCplength >= cplength && otherC.p[common2] === c.p[common2]) {
      if (c.ld !== void 0) {
        oc = clone(otherC);
        oc.p = oc.p.slice(cplength);
        c.ld = json.apply(clone(c.ld), [oc]);
      } else if (c.od !== void 0) {
        oc = clone(otherC);
        oc.p = oc.p.slice(cplength);
        c.od = json.apply(clone(c.od), [oc]);
      }
    }
    json.append(dest, c);
    return dest;
  }
  // if c is deleting something, and that thing is changed by otherC, we need to
  // update c to reflect that change for invertibility.
  // TODO this is probably not needed since we don't have invertibility
  if (common2 != null && otherCplength > cplength && c.p[common2] === otherC.p[common2]) {
    if (c.ld !== void 0) {
      oc = clone(otherC);
      oc.p = oc.p.slice(cplength);
      c.ld = json.apply(clone(c.ld), [oc]);
    } else if (c.od !== void 0) {
      oc = clone(otherC);
      oc.p = oc.p.slice(cplength);
      c.od = json.apply(clone(c.od), [oc]);
    }
  }
  if (common != null) {
    commonOperand = cplength === otherCplength;
    // transform based on otherC
    if (otherC.na !== void 0) {

      // this case is handled above due to icky path hax
    } else if (otherC.si !== void 0 || otherC.sd !== void 0) {
      // String op vs string op - pass through to text type
      if (c.si !== void 0 || c.sd !== void 0) {
        if (!commonOperand) {
          throw new Error('must be a string?');
        }
        // Convert an op component to a text op component
        convert = function convert(component) {
          var newC = void 0;
          newC = {
            p: component.p[component.p.length - 1]
          };
          if (component.si != null) {
            newC.i = component.si;
          } else {
            newC.d = component.sd;
          }
          return newC;
        };
        tc1 = convert(c);
        tc2 = convert(otherC);
        res = [];
        text._tc(res, tc1, tc2, type);
        for (j = 0, len = res.length; j < len; j++) {
          tc = res[j];
          jc = {
            p: c.p.slice(0, common)
          };
          jc.p.push(tc.p);
          if (tc.i != null) {
            jc.si = tc.i;
          }
          if (tc.d != null) {
            jc.sd = tc.d;
          }
          json.append(dest, jc);
        }
        return dest;
      }
    } else if (otherC.li !== void 0 && otherC.ld !== void 0) {
      if (otherC.p[common] === c.p[common]) {
        if (!commonOperand) {
          // we're below the deleted element, so -> noop
          return dest;
        } else if (c.ld !== void 0) {
          // we're trying to delete the same element, -> noop
          if (c.li !== void 0 && type === 'left') {
            // we're both replacing one element with another. only one can
            // survive!
            c.ld = clone(otherC.li);
          } else {
            return dest;
          }
        }
      }
    } else if (otherC.li !== void 0) {
      if (c.li !== void 0 && c.ld === void 0 && commonOperand && c.p[common] === otherC.p[common]) {
        // in li vs. li, left wins.
        if (type === 'right') {
          c.p[common]++;
        }
      } else if (otherC.p[common] <= c.p[common]) {
        c.p[common]++;
      }
      if (c.lm !== void 0) {
        if (commonOperand) {
          // otherC edits the same list we edit
          if (otherC.p[common] <= c.lm) {
            c.lm++;
          }
        }
      }
      // changing c.from is handled above.
    } else if (otherC.ld !== void 0) {
      if (c.lm !== void 0) {
        if (commonOperand) {
          if (otherC.p[common] === c.p[common]) {
            // they deleted the thing we're trying to move
            return dest;
          }
          // otherC edits the same list we edit
          p = otherC.p[common];
          from = c.p[common];
          to = c.lm;
          if (p < to || p === to && from < to) {
            c.lm--;
          }
        }
      }
      if (otherC.p[common] < c.p[common]) {
        c.p[common]--;
      } else if (otherC.p[common] === c.p[common]) {
        if (otherCplength < cplength) {
          // we're below the deleted element, so -> noop
          return dest;
        } else if (c.ld !== void 0) {
          if (c.li !== void 0) {
            // we're replacing, they're deleting. we become an insert.
            delete c.ld;
          } else {
            // we're trying to delete the same element, -> noop
            return dest;
          }
        }
      }
    } else if (otherC.lm !== void 0) {
      if (c.lm !== void 0 && cplength === otherCplength) {
        // lm vs lm, here we go!
        from = c.p[common];
        to = c.lm;
        otherFrom = otherC.p[common];
        otherTo = otherC.lm;
        if (otherFrom !== otherTo) {
          // if otherFrom == otherTo, we don't need to change our op.

          // where did my thing go?
          if (from === otherFrom) {
            // they moved it! tie break.
            if (type === 'left') {
              c.p[common] = otherTo;
              if (from === to) {
                // ugh
                c.lm = otherTo;
              }
            } else {
              return dest;
            }
          } else {
            // they moved around it
            if (from > otherFrom) {
              c.p[common]--;
            }
            if (from > otherTo) {
              c.p[common]++;
            } else if (from === otherTo) {
              if (otherFrom > otherTo) {
                c.p[common]++;
                if (from === to) {
                  // ugh, again
                  c.lm++;
                }
              }
            }
            // step 2: where am i going to put it?
            if (to > otherFrom) {
              c.lm--;
            } else if (to === otherFrom) {
              if (to > from) {
                c.lm--;
              }
            }
            if (to > otherTo) {
              c.lm++;
            } else if (to === otherTo) {
              // if we're both moving in the same direction, tie break
              if (otherTo > otherFrom && to > from || otherTo < otherFrom && to < from) {
                if (type === 'right') {
                  c.lm++;
                }
              } else {
                if (to > from) {
                  c.lm++;
                } else if (to === otherFrom) {
                  c.lm--;
                }
              }
            }
          }
        }
      } else if (c.li !== void 0 && c.ld === void 0 && commonOperand) {
        // li
        from = otherC.p[common];
        to = otherC.lm;
        p = c.p[common];
        if (p > from) {
          c.p[common]--;
        }
        if (p > to) {
          c.p[common]++;
        }
      } else {
        // ld, ld+li, si, sd, na, oi, od, oi+od, any li on an element beneath
        // the lm

        // i.e. things care about where their item is after the move.
        from = otherC.p[common];
        to = otherC.lm;
        p = c.p[common];
        if (p === from) {
          c.p[common] = to;
        } else {
          if (p > from) {
            c.p[common]--;
          }
          if (p > to) {
            c.p[common]++;
          } else if (p === to) {
            if (from > to) {
              c.p[common]++;
            }
          }
        }
      }
    } else if (otherC.oi !== void 0 && otherC.od !== void 0) {
      if (c.p[common] === otherC.p[common]) {
        if (c.oi !== void 0 && commonOperand) {
          // we inserted where someone else replaced
          if (type === 'right') {
            // left wins
            return dest;
          } else {
            // we win, make our op replace what they inserted
            c.od = otherC.oi;
          }
        } else {
          // -> noop if the other component is deleting the same object (or any
          // parent)
          return dest;
        }
      }
    } else if (otherC.oi !== void 0) {
      if (c.oi !== void 0 && c.p[common] === otherC.p[common]) {
        // left wins if we try to insert at the same place
        if (type === 'left') {
          json.append(dest, {
            p: c.p,
            od: otherC.oi
          });
        } else {
          return dest;
        }
      }
    } else if (otherC.od !== void 0) {
      if (c.p[common] === otherC.p[common]) {
        if (!commonOperand) {
          return dest;
        }
        if (c.oi !== void 0) {
          delete c.od;
        } else {
          return dest;
        }
      }
    }
  }
  json.append(dest, c);
  return dest;
};

if (typeof WEB !== 'undefined' && WEB !== null) {
  exports.types || (exports.types = {});
  // This is kind of awful - come up with a better way to hook this helper code up.
  exports._bt(json, json.transformComponent, json.checkValidOp, json.append);
  // [] is used to prevent closure from renaming types.text
  exports.types.json = json;
} else {
  module.exports = json;
  require('./helpers').bootstrapTransform(json, json.transformComponent, json.checkValidOp, json.append);
}
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// API for JSON OT

// client build is concatenating all those files into a single file and let/const variables
// can't be redeclared, while var can, disable this rule here for now
// eslint-disable-next-line no-var
var SubDoc, depath, extendDoc, json, pathEquals, traverse;

if (typeof WEB === 'undefined') {
  json = require('./json');
}

if (typeof WEB !== 'undefined' && WEB !== null) {
  extendDoc = exports.extendDoc;
  exports.extendDoc = function (name, fn) {
    SubDoc.prototype[name] = fn;
    return extendDoc(name, fn);
  };
}

depath = function depath(path) {
  if (path.length === 1 && path[0].constructor === Array) {
    return path[0];
  } else {
    return path;
  }
};

SubDoc = function () {
  function SubDoc(doc, path1) {
    _classCallCheck(this, SubDoc);

    this.doc = doc;
    this.path = path1;
  }

  SubDoc.prototype.at = function at() {
    for (var _len = arguments.length, path = Array(_len), _key = 0; _key < _len; _key++) {
      path[_key] = arguments[_key];
    }

    return this.doc.at(this.path.concat(depath(path)));
  };

  SubDoc.prototype.parent = function parent() {
    if (this.path.length) {
      return this.doc.at(this.path.slice(0, this.path.length - 1));
    } else {
      return void 0;
    }
  };

  SubDoc.prototype.get = function get() {
    return this.doc.getAt(this.path);
  };

  // for objects and lists


  SubDoc.prototype.set = function set(value, cb) {
    return this.doc.setAt(this.path, value, cb);
  };

  // for strings and lists.


  SubDoc.prototype.insert = function insert(pos, value, cb) {
    return this.doc.insertAt(this.path, pos, value, cb);
  };

  // for strings


  SubDoc.prototype.del = function del(pos, length, cb) {
    return this.doc.deleteTextAt(this.path, length, pos, cb);
  };

  // for objects and lists


  SubDoc.prototype.remove = function remove(cb) {
    return this.doc.removeAt(this.path, cb);
  };

  SubDoc.prototype.push = function push(value, cb) {
    return this.insert(this.get().length, value, cb);
  };

  SubDoc.prototype.move = function move(from, to, cb) {
    return this.doc.moveAt(this.path, from, to, cb);
  };

  SubDoc.prototype.add = function add(amount, cb) {
    return this.doc.addAt(this.path, amount, cb);
  };

  SubDoc.prototype.on = function on(event, cb) {
    return this.doc.addListener(this.path, event, cb);
  };

  SubDoc.prototype.removeListener = function removeListener(l) {
    return this.doc.removeListener(l);
  };

  // text API compatibility


  SubDoc.prototype.getLength = function getLength() {
    return this.get().length;
  };

  SubDoc.prototype.getText = function getText() {
    return this.get();
  };

  return SubDoc;
}();

traverse = function traverse(snapshot, path) {
  var container = void 0,
      elem = void 0,
      j = void 0,
      key = void 0,
      len = void 0,
      p = void 0;
  container = {
    data: snapshot
  };
  key = 'data';
  elem = container;
  for (j = 0, len = path.length; j < len; j++) {
    p = path[j];
    elem = elem[key];
    key = p;
    if (typeof elem === 'undefined') {
      throw new Error('bad path');
    }
  }
  return { elem: elem, key: key };
};

pathEquals = function pathEquals(p1, p2) {
  var e = void 0,
      i = void 0,
      j = void 0,
      len = void 0;
  if (p1.length !== p2.length) {
    return false;
  }
  for (i = j = 0, len = p1.length; j < len; i = ++j) {
    e = p1[i];
    if (e !== p2[i]) {
      return false;
    }
  }
  return true;
};

json.api = {
  provides: {
    json: true
  },
  at: function at() {
    for (var _len2 = arguments.length, path = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      path[_key2] = arguments[_key2];
    }

    return new SubDoc(this, depath(path));
  },
  get: function get() {
    return this.snapshot;
  },
  set: function set(value, cb) {
    return this.setAt([], value, cb);
  },
  getAt: function getAt(path) {
    var elem = void 0,
        key = void 0;

    var _traverse = traverse(this.snapshot, path);

    elem = _traverse.elem;
    key = _traverse.key;

    return elem[key];
  },
  setAt: function setAt(path, value, cb) {
    var elem = void 0,
        key = void 0,
        op = void 0;

    var _traverse2 = traverse(this.snapshot, path);

    elem = _traverse2.elem;
    key = _traverse2.key;

    op = {
      p: path
    };
    if (elem.constructor === Array) {
      op.li = value;
      if (typeof elem[key] !== 'undefined') {
        op.ld = elem[key];
      }
    } else if ((typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object') {
      op.oi = value;
      if (typeof elem[key] !== 'undefined') {
        op.od = elem[key];
      }
    } else {
      throw new Error('bad path');
    }
    return this.submitOp([op], cb);
  },
  removeAt: function removeAt(path, cb) {
    var elem = void 0,
        key = void 0,
        op = void 0;

    var _traverse3 = traverse(this.snapshot, path);

    elem = _traverse3.elem;
    key = _traverse3.key;

    if (typeof elem[key] === 'undefined') {
      throw new Error('no element at that path');
    }
    op = {
      p: path
    };
    if (elem.constructor === Array) {
      op.ld = elem[key];
    } else if ((typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object') {
      op.od = elem[key];
    } else {
      throw new Error('bad path');
    }
    return this.submitOp([op], cb);
  },
  insertAt: function insertAt(path, pos, value, cb) {
    var elem = void 0,
        key = void 0,
        op = void 0;

    var _traverse4 = traverse(this.snapshot, path);

    elem = _traverse4.elem;
    key = _traverse4.key;

    op = {
      p: path.concat(pos)
    };
    if (elem[key].constructor === Array) {
      op.li = value;
    } else if (typeof elem[key] === 'string') {
      op.si = value;
    }
    return this.submitOp([op], cb);
  },
  moveAt: function moveAt(path, from, to, cb) {
    var op = void 0;
    op = [{
      p: path.concat(from),
      lm: to
    }];
    return this.submitOp(op, cb);
  },
  addAt: function addAt(path, amount, cb) {
    var op = void 0;
    op = [{
      p: path,
      na: amount
    }];
    return this.submitOp(op, cb);
  },
  deleteTextAt: function deleteTextAt(path, length, pos, cb) {
    var elem = void 0,
        key = void 0,
        op = void 0;

    var _traverse5 = traverse(this.snapshot, path);

    elem = _traverse5.elem;
    key = _traverse5.key;

    op = [{
      p: path.concat(pos),
      sd: elem[key].slice(pos, pos + length)
    }];
    return this.submitOp(op, cb);
  },
  addListener: function addListener(path, event, cb) {
    var l = void 0;
    l = { path: path, event: event, cb: cb };
    this._listeners.push(l);
    return l;
  },
  removeListener: function removeListener(l) {
    var i = void 0;
    i = this._listeners.indexOf(l);
    if (i < 0) {
      return false;
    }
    this._listeners.splice(i, 1);
    return true;
  },
  _register: function _register() {
    this._listeners = [];
    this.on('change', function (op) {
      var c = void 0,
          dummy = void 0,
          i = void 0,
          j = void 0,
          k = void 0,
          l = void 0,
          len = void 0,
          len1 = void 0,
          ref = void 0,
          results = void 0,
          to_remove = void 0,
          xformed = void 0;
      results = [];
      for (j = 0, len = op.length; j < len; j++) {
        c = op[j];
        if (c.na !== void 0 || c.si !== void 0 || c.sd !== void 0) {
          // no change to structure
          continue;
        }
        to_remove = [];
        ref = this._listeners;
        for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
          l = ref[i];
          // Transform a dummy op by the incoming op to work out what
          // should happen to the listener.
          dummy = {
            p: l.path,
            na: 0
          };
          xformed = this.type.transformComponent([], dummy, c, 'left');
          if (xformed.length === 0) {
            // The op was transformed to noop, so we should delete the listener.
            to_remove.push(i);
          } else if (xformed.length === 1) {
            // The op remained, so grab its new path into the listener.
            l.path = xformed[0].p;
          } else {
            throw new Error("Bad assumption in json-api: xforming an 'si' op will always result in 0 or 1 components.");
          }
        }
        to_remove.sort(function (a, b) {
          return b - a;
        });
        results.push(function () {
          var len2 = void 0,
              m = void 0,
              results1 = void 0;
          results1 = [];
          for (m = 0, len2 = to_remove.length; m < len2; m++) {
            i = to_remove[m];
            results1.push(this._listeners.splice(i, 1));
          }
          return results1;
        }.call(this));
      }
      return results;
    });
    return this.on('remoteop', function (op) {
      var c = void 0,
          cb = void 0,
          child_path = void 0,
          event = void 0,
          j = void 0,
          len = void 0,
          match_path = void 0,
          path = void 0,
          results = void 0;
      results = [];
      for (j = 0, len = op.length; j < len; j++) {
        c = op[j];
        match_path = c.na === void 0 ? c.p.slice(0, c.p.length - 1) : c.p;
        results.push(function () {
          var k = void 0,
              len1 = void 0,
              ref = void 0,
              results1 = void 0;
          ref = this._listeners;
          results1 = [];
          for (k = 0, len1 = ref.length; k < len1; k++) {
            var _ref$k = ref[k];
            path = _ref$k.path;
            event = _ref$k.event;
            cb = _ref$k.cb;

            if (pathEquals(path, match_path)) {
              switch (event) {
                case 'insert':
                  if (c.li !== void 0 && c.ld === void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.li));
                  } else if (c.oi !== void 0 && c.od === void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.oi));
                  } else if (c.si !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.si));
                  } else {
                    results1.push(void 0);
                  }
                  break;
                case 'delete':
                  if (c.li === void 0 && c.ld !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.ld));
                  } else if (c.oi === void 0 && c.od !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.od));
                  } else if (c.sd !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.sd));
                  } else {
                    results1.push(void 0);
                  }
                  break;
                case 'replace':
                  if (c.li !== void 0 && c.ld !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.ld, c.li));
                  } else if (c.oi !== void 0 && c.od !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.od, c.oi));
                  } else {
                    results1.push(void 0);
                  }
                  break;
                case 'move':
                  if (c.lm !== void 0) {
                    results1.push(cb(c.p[c.p.length - 1], c.lm));
                  } else {
                    results1.push(void 0);
                  }
                  break;
                case 'add':
                  if (c.na !== void 0) {
                    results1.push(cb(c.na));
                  } else {
                    results1.push(void 0);
                  }
                  break;
                default:
                  results1.push(void 0);
              }
            } else if (this.type.canOpAffectOp(path, match_path)) {
              if (event === 'child op') {
                child_path = c.p.slice(path.length);
                results1.push(cb(child_path, c));
              } else {
                results1.push(void 0);
              }
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        }.call(this));
      }
      return results;
    });
  }
};; }).call(this);


// WEBPACK FOOTER //
// ./public/app/sharejs-types.js